import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';
import ItemWrapper from './ItemWrapper';
import Title from './Title';
import CheckboxWithOnly from './CheckboxWithOnly';
import {formatPrice} from 'lib/helpers/globalize-helper';

const getTrName = (name, transportationTypes) => {
  switch (name) {
  case 'train':
    return transportationTypes.rails;
  case 'bus':
    return transportationTypes.bus;
  default:
    return transportationTypes.flight;
  }
};

class Transportations extends Component {
  state = {
    show: true
  };

  toggleFilter = () => this.setState((prevState) => ({show: !prevState.show}));

  toggleTransportation = (e) => this.props.toggleTransportation(e.target.value);

  render() {
    const {show} = this.state;
    const {
      allTransportationsAreChecked, transportTypes,
      selectSingleTransportation, toggleAllTransportations, currency, translations
    } = this.props;
    const {transportationTypes, metaResults: {allTransportationTypes, transportationType}} = translations;
    const ALL = 'all';

    return (
      <ItemWrapper>
        <Title
          title={transportationType}
          isOpen={show}
          onClick={this.toggleFilter}
        />
        <Collapse in={show}>
          <div className="filter-content">

            <CheckboxWithOnly
              key={ALL}
              value={ALL}
              isChecked={allTransportationsAreChecked}
              label={allTransportationTypes}
              onChange={() => toggleAllTransportations()}
            />

            {
              transportTypes.options.map(({name, price}) => (
                <CheckboxWithOnly
                  key={name}
                  value={name}
                  isChecked={transportTypes.selectedOptions.indexOf(name) !== -1}
                  label={getTrName(name, transportationTypes)}
                  price={formatPrice(price, currency)}
                  onChange={this.toggleTransportation}
                  onClickOnly={selectSingleTransportation}
                  translations={translations}
                />))
            }
          </div>
        </Collapse>
      </ItemWrapper>
    );
  }
}

Transportations.propTypes = {
  transportTypes: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
    options: PropTypes.array,
    selectedOptions: PropTypes.array
  }),
  allTransportationsAreChecked: PropTypes.bool.isRequired,
  selectSingleTransportation: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  toggleAllTransportations: PropTypes.func.isRequired,
  toggleTransportation: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    transportationTypes: PropTypes.string.isRequired,
    metaResults: PropTypes.shape({
      allTransportationTypes: PropTypes.string,
      transportationType: PropTypes.number
    })
  })
};

export default Transportations;
